import { Box, Button, Card, CardContent, CardMedia } from '@mui/material'
import React, { useState } from 'react'
import thanks from "../assets/img/like.svg"
import feedback from "../assets/img/comment.svg"
import complaint from "../assets/img/unlike.svg"
import safety from "../assets/img/safety.svg"
import justice from "../assets/img/justice.svg"
import award from "../assets/img/award.svg"
import FeedBacks from '../components/modals/FeedBacks'

const urlData = [
  {
    title: "Teşekkür",
    url: "/tesekkur",
    icon: thanks,
  },
  {
    title: "Talep",
    url: "/oneritalep",
    icon: feedback,
  },
  {
    title: "Şikayet",
    url: "/sikayet",
    icon: complaint,
  },
  {
    title: "Etik",
    url: "/etiklik",
    icon: justice,
  },
  {
    title: "Tehlikeli Durum & Ramak Kala",
    url: "/ramakkala",
    icon: safety,
  },
  /*{
    title: "Ödül Öneri",
    url: "/odul-oneri/basvuru",
    icon: award,
  },*/
]

export const Home = () => {

  const [info, setInfo] = useState("")

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCardClick = (item) => {
    setInfo(item.title)
    handleOpen()
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', py: 15, gap: 5 }}>
      {
        urlData?.map((item, index) => (
          <Card sx={{
            maxWidth: '300px',
            boxShadow: 'none',
            backgroundColor: 'transparent',
            p: 3,
            '&:hover': { boxShadow: '0px 2px 4px #A69B95' }
          }} key={index} >
            <CardMedia
              component='img'
              image={item.icon}
              height='175'
              sx={{ objectFit: 'cover', width: '50%', margin: 'auto', cursor: 'pointer' }}
              onClick={() => handleCardClick(item)}
            />
            <CardContent>
              <Button fullWidth variant='outlined' color='warning' sx={{ textTransform: 'none', fontSize: '20px' }}
                onClick={() => handleCardClick(item)}>{item.title}</Button>
            </CardContent>

            <FeedBacks open={open} handleClose={handleClose} info={info} />
          </Card>
        ))
      }
    </Box>
  )
}
